import {isMobile} from "../../../../util/misc.js";

export const options = {
    animation: true,
    maintainAspectRatio: false,
    interaction: {
        mode: 'index',
        axis: 'x',
        intersect: false,
    },
    elements: {
        line: {
            tension: 0.15
        },
    },
    events: ['mouseenter', 'mouseleave', 'mouseout', 'mousedown', 'mouseup', 'mousemove'],
    plugins: {
        tooltip: {
            enabled: true,
        },
        legend: {
            display: false,
        },
    },
    scales: {
        x: {
            type: 'time',
            time: {
                round: 'second',
                displayFormats: {
                    // month: 'MMMM YYYY',
                    hour: 'MM-DD HH:ii',
                    minute: 'HH:mm',
                },
            },
            border: {
                display: false,
            },
            ticks: {
                display: false,
            },
            grid: {
                display: false,
            },
        },
        y: {
            padding: 0,
            beginAtZero: false,
            border: {
                display: !isMobile(),
            },
            ticks: {
                display: isMobile(),
            },
            grid: {
                display: false,
            },
        }
    }
}